import React, { Component } from "react";
import "./Login.css";
import axios from "axios";
import spatiam_logo from "../assets/spatiam_logo_white.png";
import login_image from "../assets/manager_graphic17.png";
import Signin from "./Signin"
import Register from "./Register"
import { withRouter } from 'react-router-dom';

class Login extends Component {
  state = {
    credentials: { username: "", password: "" },
    validationErrors: [],
    modal: this.props.signin,
    registered: false,
  };

  setRegistered = (isRegistered) => {
    this.setState({ registered: isRegistered });
  }

  getRegistered = () => {
    return this.state.registered;
  }

  toggle = () => {
    this.setState({ modal: !this.state.modal });
  };

  login = (event) => {
    let service = axios.create({
      baseURL: this.props.baseUrl + "/api",
      responseType: "json",
    });

    service
      .post("/auth/", this.state.credentials)
      .then((response) => {
        if (response.data.token) {
          this.props.userToken(response.data.token);
          this.props.userLogin(this.state.credentials.username);
        }
      })
      .catch((errors) => {
        this.setState({ validationErrors: errors.response.data });
      });
    return;
  };

  register = (event) => {
    let service = axios.create({
      baseURL: this.props.baseUrl + "/api",
      responseType: "json",
    });

    service
      .post("/api/users/", this.state.credentials)
      .then((response) => {
        this.login();
      })
      .catch((error) => {
      });
    return;
  };

  inputChanged = (event) => {
    const cred = this.state.credentials;
    cred[event.target.name] = event.target.value;
    this.setState({ credentials: cred });
  };

  renderErrors = () => {
    const validationErrors = this.state.validationErrors;

    const error_tags = ["username", "password", "non_field_errors"];
    let errors = [];

    var arrayLength = error_tags.length;
    for (var i = 0; i < arrayLength; i++) {
      const error_tag = error_tags[i];
      const error_msg = validationErrors[error_tag];
      var msg = "";
      if (error_msg) {
        if (error_tag === "username") {
          msg = "Enter username";
        } else if (error_tag === "password") {
          msg = "Enter password";
        } else {
          msg = "The info doesn't match our records.\t Please try again.";
        }
        errors.push(<li key={error_tags[i]}>{msg}</li>);
      }
    }

    return errors;
  };

  render() {
    return (
      <div className="login">
        <div className="login_page">
          <a href="https://www.spatiam.com/">
            <img className="logo_image" src={spatiam_logo} alt="logo" />
          </a>
          <div className="login_area">
            <div className="input_area">

            {this.state.modal ? (
              <Signin baseUrl={this.props.baseUrl} baseDir={this.props.baseDir} toggle={this.toggle} getRegistered={this.getRegistered} setRegistered={this.setRegistered} userToken={this.props.userToken} userLogin={this.props.userLogin} setCookie={this.props.setCookie}/>
            ) : 
              <Register baseUrl={this.props.baseUrl} baseDir={this.props.baseDir} toggle={this.toggle} getRegistered={this.getRegistered} setRegistered={this.setRegistered} userToken={this.props.userToken} userLogin={this.props.userLogin}/>}
              
            </div>
            <div className="image_area">
              <img className="login_image" src={login_image} alt="Manage Your DTN Networks" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
